export default __webpack_public_path__ + "static/media/error_icon_round@3x.5138f21e.svg";